import { useState } from 'react'
import DataTable from '../components/DataTable';
import { KTSVG } from '../../_metronic/helpers'
import ParentCompanyCreate from '../components/ParentCompanyCreate';

function ParentCompanyList() {

    const [newData, setNewData] = useState({});
    const [id, setId] = useState(0);

    const [createParentCompanyModalShow, setCreateParentCompanyModalShow] = useState(false);

    const handleCreateParentCompanyModalShow = () => {
        setId(0);
        setCreateParentCompanyModalShow(true);
    }

    const handleCreateParentCompanyModalClose = (isReload: boolean) => {
        setCreateParentCompanyModalShow(false);
        if (isReload) {
            setNewData({ id: Date.now() });
        }
    }

    const editParentCompany = (id: number): void => {
        setId(id);
        setCreateParentCompanyModalShow(true);
    };

    const columns = [
        { value: 'id', title: 'Id', style: { textAlign: 'center' } },
        { value: 'name', title: 'Name', style: { textAlign: 'left' } },
        { value: 'binNumber', title: 'BIN Number', style: { textAlign: 'left' } },
        { value: 'address', title: 'Address', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return (
                    <>
                        <button className="btn btn-light-primary btn-sm" onClick={() => editParentCompany(row.id)}>
                            <KTSVG
                                path='/media/svg/icons/Communication/Write.svg'
                                className='svg-icon-5 svg-icon'
                            />		Edit
                        </button>
                    </>
                )
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        name: {
            filterType: 'like',
            filterValue: '',
        },
        binNumber: {
            filterType: 'like',
            filterValue: '',
        },
        address: {
            filterType: 'like',
            filterValue: '',
        },
    }

    const url = process.env.REACT_APP_API_URL + 'parent-company/dt'

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header'>
                    <div className="card-title">
                        <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                        <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                            Parent Company List
                        </span>
                    </div>
                    <div className="card-toolbar">
                        <div className='d-flex justify-content-end'>
                            <button type="button" className="btn btn-sm btn-primary" onClick={() => handleCreateParentCompanyModalShow()}><i className="fa fa-plus"></i>Add Parent Company</button>
                        </div>
                    </div>
                </div>

                <div className='card-body'>
                    <DataTable url={url} columns={columns} filters={filters} newData={newData} />
                </div>
            </div>

            <ParentCompanyCreate show={createParentCompanyModalShow} handleClose={handleCreateParentCompanyModalClose} id={id} />
        </>
    )
}

export default ParentCompanyList
